import { Injectable } from '@angular/core';
import { UserResponseData } from '../dto/authentication.dto';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {

    private readonly TOKEN_KEY: string = 'votapp_token';
    private readonly USER_KEY: string = 'votapp_user';

    private parseValue(value: string | null): any {
        return value ? JSON.parse(value) : null;
    }

    private getItem(key: string): any {
        return typeof window !== 'undefined' ? this.parseValue(localStorage.getItem(key)) : null;
    }

    private setItem(key: string, value: any): void {
        if (typeof window !== 'undefined') localStorage.setItem(key, JSON.stringify(value));
    }

    private removeItem(key: string): void {
        if (typeof window !== 'undefined') localStorage.removeItem(key);
    }

    public getToken(): string | null {
        return this.getItem(this.TOKEN_KEY);
    }

    public getUser(): UserResponseData | null {
        return this.getItem(this.USER_KEY);
    }

    public setToken(value: string): void {
        this.setItem(this.TOKEN_KEY, value);
    }

    public setUser(value: UserResponseData): void {
        this.setItem(this.USER_KEY, value);
    }

    public removeToken(): void {
        this.removeItem(this.TOKEN_KEY);
    }

    public removeUser(): void {
        this.removeItem(this.USER_KEY);
    }

}
